export enum ArrowStyleTypes {
  none = 'none',
  lineArrow = 'lineArrow',
  basic = 'basic',
  outlineBasic = 'outlineBasic',
  long = 'long',
  sharp = 'sharp',
  line = 'line',
  circle = 'circle',
  outlineCircle = 'outlineCircle',
  diamond = 'diamond',
  outlineDiamond = 'outlineDiamond',
}

export enum LineWidgetDashArrayTypes {
  solid = 'solid',
  dotted = 'dotted',
  dashed = 'dashed',
  dashDot = 'dashDot',
  longDash = 'longDash',
  longDashDot = 'longDashDot',
}

export type LineWidgetDashArrayTypeKeys = keyof typeof LineWidgetDashArrayTypes;
export type ArrowStyleTypeKeys = keyof typeof ArrowStyleTypes;
